<section class="Auto_Popup_CurationCloningSelection">
  <div>You are about to clone a curation item with {{fieldToChange}} <b>{{currentField}}</b>
    <br>Please enter a new {{fieldToChange}}:<br><br></div>
  <gen-dynamic-form
    [formData]="formData"
    [formName]="selectedFormName"
    [formVertical]="true"
    (submitEmitter)="submit($event)"
    (validateChange)="updateValidate($event)"
    (formChange)="updateForm($event.form)"
    [submitted]="submitted"
    [popupMode]="true"
    [valid]="isValid">
  </gen-dynamic-form>
</section>
